import { render, staticRenderFns } from "./CreateRevWrapper.vue?vue&type=template&id=39a1d774&scoped=true"
import script from "./CreateRevWrapper.vue?vue&type=script&lang=js"
export * from "./CreateRevWrapper.vue?vue&type=script&lang=js"
import style0 from "./CreateRevWrapper.vue?vue&type=style&index=0&id=39a1d774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1d774",
  null
  
)

export default component.exports